<template>
  <i-drawer
    v-model="_drawer"
    placement="left"
    title="設定"
    :closable="false"
    @on-visible-change="onVisibleChange"
    width="640"
    class="drawer-setting"
  >
    <div class="drawer-setting">
      <h3 class="drawer-setting__title">表示設定</h3>
      <SettingTableColumns :columns="columns" :type="type" />
      <SettingConvertInstruction :type="type" />

      <h3 class="drawer-setting__title">コンバート設定</h3>
      <SettingConvertDisplay :type="type" />

      <h3 class="drawer-setting__title">管理者設定</h3>
      <SettingDeletePassword />
    </div>
  </i-drawer>
</template>

<script>
import { Drawer } from 'view-design'
import SettingTableColumns from '@/components/templates/drawer/SettingTableColumns'
import SettingConvertInstruction from '@/components/templates/drawer/SettingConvertInstruction'
import SettingConvertDisplay from '@/components/templates/drawer/SettingConvertDisplay'
import SettingDeletePassword from '@/components/templates/drawer/SettingDeletePassword'
export default {
  components: {
    'i-drawer': Drawer,
    SettingTableColumns,
    SettingConvertInstruction,
    SettingConvertDisplay,
    SettingDeletePassword,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
      requied: true,
    },
    columns: {
      type: Array,
      default: () => [],
      requied: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    _drawer: {
      get() {
        return this.drawer
      },
      set(val) {
        this.$emit('update:drawer', val)
      },
    },
  },
  methods: {
    // ドロワー 表示/非表示 切り替え時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // 表示時処理
      } else {
        // 非表示時処理
      }
    },
  },
}
</script>

<style lang="scss">
.drawer-setting {
  background-color: #fff;
  &__title {
    margin: 1.5em 0 1em;
    &:first-child {
      margin: 1em 0;
    }
  }
}
</style>
